(function () {
  if (window.__bigoneSkuKods) return;
  window.__bigoneSkuKods = true;

  // Relabel the product SKU field label "SKU" -> "Kods".
  // Scoped strictly to the SKU block (element id starts with "Sku-"),
  // so only the label text is touched, never the code value itself.
  function relabel(root) {
    var boxes = (root || document).querySelectorAll('[id^="Sku-"]');
    for (var i = 0; i < boxes.length; i++) {
      var walker = document.createTreeWalker(boxes[i], NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = walker.nextNode())) {
        if (n.nodeValue && /SKU/i.test(n.nodeValue)) {
          n.nodeValue = n.nodeValue.replace(/SKU/gi, 'Kods');
        }
      }
    }
  }

  function run() { try { relabel(document); } catch (e) {} }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-apply after variant swaps / dynamic re-renders of the product info.
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    var go = function () { scheduled = false; run(); };
    if (window.requestAnimationFrame) window.requestAnimationFrame(go); else setTimeout(go, 50);
  }
  try {
    var target = document.getElementById('MainContent') || document.body;
    new MutationObserver(schedule).observe(target, { childList: true, subtree: true });
  } catch (e) {}
})();
